import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DiagnosticReport } from '../../interfaces/diagnostic-report';
import { ApiSingleResponse } from '../../interfaces/responses/api-response';

/** Rapport de diagnostic d'un élève. */
@Injectable({ providedIn: 'root' })
export class DiagnosticReportService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.BASE_URL}/diagnostic-reports`;

  /**
   * Rapport d'un élève.
   *
   * @param subjectId Restreindre à une matière. Sans cela, le rapport couvre
   * toutes celles où un diagnostic a été passé — chacune gardant son palier,
   * un élève pouvant être excellent dans l'une et en difficulté dans l'autre.
   */
  getForStudent(
    studentId: number,
    language = 'ar',
    subjectId?: number,
  ): Observable<DiagnosticReport> {
    return this.http
      .get<ApiSingleResponse<DiagnosticReport>>(
        `${this.baseUrl}/students/${studentId}`,
        { params: this.params(language, subjectId) },
      )
      .pipe(map((r) => r.data));
  }

  /** Rapport de l'élève connecté. */
  getMine(language = 'ar', subjectId?: number): Observable<DiagnosticReport> {
    return this.http
      .get<ApiSingleResponse<DiagnosticReport>>(`${this.baseUrl}/me`, {
        params: this.params(language, subjectId),
      })
      .pipe(map((r) => r.data));
  }

  private params(language: string, subjectId?: number): HttpParams {
    let params = new HttpParams().set('language', language);
    if (subjectId) params = params.set('subjectId', subjectId);
    return params;
  }
}
